import { render, staticRenderFns } from "./Profile-User-Regist.vue?vue&type=template&id=4d12197c&scoped=true&"
import script from "./Profile-User-Regist.vue?vue&type=script&lang=js&"
export * from "./Profile-User-Regist.vue?vue&type=script&lang=js&"
import style0 from "./Profile-User-Regist.vue?vue&type=style&index=0&id=4d12197c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d12197c",
  null
  
)

export default component.exports